import { Mediator, payload } from "modular-openscriptjs";
import { approved, eParse, inform } from "../helpers";
import { api, STRINGS } from "../declarations";
import { $e } from "../ojs.events";

export default class ServiceMediator extends Mediator {
  $$service = {
    needs: {
      deletion: (ed, event) => this.deleteService(ed, event),
      creation: (ed, event) => this.saveService(ed, event),
      update: (ed, event) => this.updateService(ed, event),
    },
  };

  async saveService(ed, event) {
    const { message } = eParse(ed);
    const { formData, businessId } = message;

    const res = await api.post(`companies/${businessId}/services`, formData);

    if (!res) {
      inform("Failed to save service", STRINGS.ERROR);
      return this.send($e.service.has.creationError, ed);
    }

    inform("Service saved successfully", STRINGS.SUCCESS);
    this.send($e.service.created, payload({ service: res.data }));
  }

  async deleteService(ed, event) {
    if (!approved(event, ed, "Are you sure you want to delete this service?"))
      return;

    const { message } = eParse(ed);

    const res = await api.delete(
      `companies/${message.businessId}/services/${message.id}`,
      {
        organization: {
          id: message.businessId,
          type: "Company",
        }
      }
    );

    if (!res) {
      inform("Failed to delete service", STRINGS.ERROR);
      return this.send($e.service.has.deletionError, ed);
    }

    inform("Service deleted successfully", STRINGS.SUCCESS);
    this.send($e.service.deleted, payload({ id: message.id }));
  }

  async updateService(ed, event) {
    const { message } = eParse(ed);
    const { formData, businessId, id } = message;

    const res = await api.put(
      `companies/${businessId}/services/${id}`,
      formData,
    );

    if (!res) {
      inform("Failed to update service", STRINGS.ERROR);
      return this.send($e.service.has.updateError, ed);
    }

    inform("Service updated successfully", STRINGS.SUCCESS);
    this.send($e.service.updated, payload({ service: res.data }));
  }
}
